module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jobs"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加岗位")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable jobConTable",
    class: {
      overLengthTable: _vm.jobsList.length > _vm.pageSize
    }
  }, _vm._l((_vm.jobsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "left1",
      staticStyle: {
        "width": "66%",
        "text-align": "left"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "center"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-switch', {
      attrs: {
        "title": '当前岗位是否开启呼叫',
        "on-text": "",
        "off-text": "",
        "on-color": "#51BE7E",
        "off-color": "#E06C6C"
      },
      on: {
        "change": function($event) {
          return _vm.changeReward(item)
        }
      },
      model: {
        value: (item.reward),
        callback: function($$v) {
          _vm.$set(item, "reward", $$v)
        },
        expression: "item.reward"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "center"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-switch', {
      attrs: {
        "title": '当前岗位是否展示在语音呼叫客户端',
        "on-text": "",
        "off-text": "",
        "on-color": "#51BE7E",
        "off-color": "#E06C6C"
      },
      on: {
        "change": function($event) {
          return _vm.changeShowStatue(item)
        }
      },
      model: {
        value: (item.show),
        callback: function($$v) {
          _vm.$set(item, "show", $$v)
        },
        expression: "item.show"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.getCurJob(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      staticStyle: {
        "margin-right": "10%"
      }
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delJob(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.curJobId ? '修改岗位' : '添加岗位',
      "visible": _vm.addJobVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newJob.name),
      expression: "newJob.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入岗位名称"
    },
    domProps: {
      "value": (_vm.newJob.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newJob, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix groupRoles"
  }, [_c('span', {
    staticClass: "left itemName permissions"
  }, [_c('i', [_vm._v("*")]), _vm._v("选择权限")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.newJob.groupRoles),
      callback: function($$v) {
        _vm.$set(_vm.newJob, "groupRoles", $$v)
      },
      expression: "newJob.groupRoles"
    }
  }, [_c('div', {
    staticClass: "rowItem rowItemDisabled"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_CLERK",
      "disabled": ""
    }
  }, [_vm._v("店员宝登录（关注公众号'店员宝'）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_POS"
    }
  }, [_vm._v("收银端登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_PARTNER"
    }
  }, [_vm._v("我的店铺（关注公众号'店员宝'-'我的店铺'")])], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "opacity": "0"
    }
  }, [_vm._v("我的店铺店铺")]), _vm._v(" "), _c('span', [_vm._v("适应于 老板/股东 查看报表）")])]), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_STOCK"
    }
  }, [_vm._v("库存管理权限")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_ADMIN"
    }
  }, [_vm._v("后台管理系统登录")])], 1)])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addJob
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable jobTitleTable"
  }, [_c('tr', [_c('th', {
    staticClass: "left1",
    staticStyle: {
      "width": "66%",
      "text-align": "left"
    }
  }, [_vm._v("岗位名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "center"
    }
  }, [_vm._v("是否开启呼叫")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "center"
    }
  }, [_vm._v("展示在呼叫客户端")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-24e2f112","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/jobs/jobs.vue
// module id = 932
// module chunks = 1